import {Component, HostListener} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faArrowCircleLeft,
  faCar,
  faCheck,
  faCircleXmark,
  faCopy,
  faFileExcel,
  faMagnifyingGlass,
  faPen,
  faPenToSquare,
  faSquarePlus,
  faTrash,
  faUpload
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {getFileNameFromResponse} from '../../../common/utils';
import saveAs from 'file-saver';
import {GenericSearchComponent} from '../../shared/search-suggestion/search-suggestion.component';
import {AuthService} from '../../services/auth.service';
import {CopyButtonComponent} from '../../shared/copy-button/copy-button.component';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../../shared/constants/pagination.constants';
import {ReportingDatePipe} from '../../shared/datetime/reporting-date.pipe';
import {SharedTableToolbarComponent} from '../../shared/table-toolbar/shared-table-toolbar.component';
import {VtePaginationComponent} from '../../shared/vte/vte-pagination/vte-pagination.component';
import {
  cameraDeviceHealthUnavailable,
  cameraExpandAriaLabel,
  CameraListRow,
  formatCameraNameDisplay,
  formatCorrelationWindowSeconds,
  formatEnabledAnalyticsList,
  formatOptionalStatusValue,
  nextExpandedCameraId,
} from './view-cameras-status.helpers';
import {CameraDirectionIndicatorComponent} from '../../shared/camera-direction/camera-direction-indicator.component';


@Component({
    selector: 'app-view-cameras',
    imports: [
        ReportingDatePipe,
        CommonModule,
        FormsModule,
        FontAwesomeModule,
        GenericSearchComponent,
        CopyButtonComponent,
        SharedTableToolbarComponent,
        VtePaginationComponent,
        CameraDirectionIndicatorComponent,
    ],
    templateUrl: './view-cameras.component.html',
    styleUrl: './view-cameras.component.css'
})
export class ViewCamerasComponent {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
  searchText: string | null = '';
  recordsPerPage: number = 10;
  currentPage: number = 1;
    cameraData: CameraListRow[] = [];
  nextPage: number | null = null;
  previousPage: number | null = null;
  limit: number = 10;
  showConfirmationDialog: boolean = false;
  pId: number = 0;
  totalRecords:number = 0;
  showReason: Boolean = false;
  reason: string = '';
  role: string = ''
  orgId!:number;
  orgName!:string;
  isSuperUser: boolean = false;
    expandedCameraId: number | null = null;

  constructor(private apiService: ApiService,
    library: FaIconLibrary,
    private router: Router,
    private toastr:ToastrService,
    private authService: AuthService,
    private route: ActivatedRoute
    ) {
      
    
    library.addIcons(faTrash,
                    faFileExcel,
                    faAngleRight,
                    faAngleLeft,
                    faUpload,
                    faSquarePlus,
                    faMagnifyingGlass,
                    faPen,
                    faPenToSquare,
                    faCar,
                    faCheck,
                    faCircleXmark,
                    faArrowCircleLeft,
                    faCopy,
                    faSquarePlus
                  );
    this.route.queryParams.subscribe(params => {
      this.orgId = params['id'];
      this.orgName = params['name'];

    });
    const userRole = localStorage.getItem('user');
    if (userRole) {
      const roleObj = JSON.parse(userRole);
      this.role = roleObj['groups'];
        this.isSuperUser = this.authService.isSuperUser();
    }
    this.fetchData(this.currentPage, this.recordsPerPage);
    // let userObj = this.authService.getCurrentUserInfo();
    // this.orgId = userObj.id
    
  }

  fetchData(page: number, pageSize: number){
      this.expandedCameraId = null;
    this.apiService.viewCameras(page, pageSize, this.searchText, this.orgId).subscribe({
      next: (data: any) => {
      this.cameraData = data['results'];
      this.totalRecords = data['count'];
      this.nextPage = data['next']
      this.previousPage = data['previous']
    }
  });
  }

    isCameraRowExpanded(record: CameraListRow): boolean {
        return record?.id != null && this.expandedCameraId === record.id;
    }

    toggleCameraRowExpand(record: CameraListRow, event: Event): void {
        event.stopPropagation();
        this.expandedCameraId = nextExpandedCameraId(this.expandedCameraId, record?.id);
    }

    cameraEnabledAnalyticsLabel(record: CameraListRow): string {
        return formatEnabledAnalyticsList(record);
    }

    cameraOptionalValue(value: string | number | null | undefined): string {
        return formatOptionalStatusValue(value);
    }

    cameraNameDisplay(description: string | null | undefined): string {
        return formatCameraNameDisplay(description);
    }

    cameraCorrelationWindowLabel(value: number | null | undefined): string {
        return formatCorrelationWindowSeconds(value);
    }

    cameraDeviceHealthMissing(record: CameraListRow): boolean {
        return cameraDeviceHealthUnavailable(record);
    }

    cameraExpandControlLabel(expanded: boolean): string {
        return cameraExpandAriaLabel(expanded);
    }
 
  get totalPages(): number {
    let totalPage =  Math.ceil(this.totalRecords / this.recordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
    }

  next() {
    if (this.nextPage){
      this.currentPage++;
      this.fetchData(this.currentPage, this.recordsPerPage)
    }
  }

  previous() {
    if (this.previousPage){
      this.currentPage--;
      this.fetchData(this.currentPage, this.recordsPerPage)
      }
  }

  selectPageSize(){
    if(this.recordsPerPage){
      // debugger;
      this.currentPage = 1;
      this.fetchData(this.currentPage, this.recordsPerPage)
    }
  }

    onPageChange(page: number): void {
        this.currentPage = page;
        this.fetchData(this.currentPage, this.recordsPerPage);
    }

    onPageSizeChange(pageSize: number): void {
        this.recordsPerPage = pageSize;
        this.currentPage = 1;
        this.fetchData(this.currentPage, this.recordsPerPage);
    }
  


  vehicleSearch(){

    alert('Not yet implemented!.')
   
  }

  exportToExcel() {
    this.apiService.exportCamera(this.currentPage, this.recordsPerPage, this.searchText).subscribe({
          next: (response: any) => {
            const fileName = getFileNameFromResponse(response);
              if (response.body) {
                  saveAs(response.body, fileName);
              }
            
          },
          error: (err) => {
            this.toastr.error(`${err}`, 'Error')
          }
        });
    }


    openReason(reason: string | null | undefined) {
        this.reason = (reason ?? '').toString();
    this.showReason = true;
  }

  closeReason() {
    this.showReason = false;
  }
  
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const modalElement = document.querySelector('.modal-content');
    if (modalElement && !modalElement.contains(target)) {
      this.showReason = false;
    }
  }
  backPage(){
    this.router.navigate(['organization'], {state: {'activeTab': 'customer'}})
  }


  openConfirmationDialog(index: number) {
    this.showConfirmationDialog = true;
    this.pId = index;
  }

  closeConfirmationDialog() {
    this.showConfirmationDialog = false;
  }

  confirmDelete() {
    this.apiService.deleteCamera(this.pId, this.orgId).subscribe({
      next: (response:any) => {
        this.toastr.success('Camera deleted successfully.', 'Success');
        this.closeConfirmationDialog();
        window.location.reload();
      },
      error: (err) => {
        if (err['error']['detail']) {
            this.toastr.error(err['error']['detail'], 'Error');
          
        }  else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error("Something went wrong!", 'Error');
        }
        this.closeConfirmationDialog();
      }
    })
  }

  updateCamera(pk: number){
    return this.router.navigate([`edit-camera/${pk}/`], { queryParams: {'org_id': this.orgId}})
  }

    toggleCameraStatus(record: CameraListRow, event?: Event) {
    const target = event?.target as HTMLInputElement | undefined;
    const nextStatus = target ? target.checked : !record.is_active;
    const previousStatus = record.is_active;
    record.is_active = nextStatus;
    record._toggling = true;
    this.apiService.updateCamera(record.id, this.orgId, { is_active: nextStatus }).subscribe({
      next: () => {
        record._toggling = false;
        this.toastr.success(`Camera ${nextStatus ? 'enabled' : 'disabled'} successfully.`, 'Success');
      },
      error: (err) => {
        record.is_active = previousStatus;
        record._toggling = false;
        if (err['error']?.detail) {
          this.toastr.error(err['error']['detail'], 'Error');
        } else if (err['status'] !== 403 && err.status !== 0) {
          this.toastr.error('Something went wrong!', 'Error');
        }
      }
    });
  }

  addCamera(){
    if (!this.isSuperUser) {
      return;
    }
    this.router.navigate(['/add-camera'], { queryParams: {'id': this.orgId, 'name': this.orgName}})

  }

  onResults(event: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
      this.expandedCameraId = null;
  this.currentPage = 1;
  this.recordsPerPage = 10;
  this.previousPage = event.previousPage;
  this.nextPage = event.nextPage;
  this.searchText = event.searchText;
  this.cameraData = event.results;
  this.totalRecords = event.totalRecords;
}
  
}
